<template>
    <div class="dropdown-menu__list">
        <a
            v-for="customer in switchToCustomers"
            :key="customer.id"
            :title="customer.name"
            class="dropdown-menu__list-item"
            @click="switchToCustomer(customer)"
        >
            <span class="dropdown-menu__item">
                <slot />

                <span class="dropdown-menu__organization">
                    {{ customer.name }}
                </span>
                - {{ customer.customerNumber }}
            </span>
        </a>
    </div>
</template>

<script>
import CustomerModel from '../models/Customer.js';
export default {
    props: {
        customers: {
            type: Array,
            required: true,
            validator: customers => customers.every(customer => customer instanceof CustomerModel)
        },
        currentCustomer: {
            type: CustomerModel,
            required: true
        }
    },
    computed: {
        /**
         * Remove current customer from customer list
         *
         * @returns {array}
         */
        switchToCustomers() {
            return this.customers.filter(customer => customer.id !== this.currentCustomer.id);
        }
    },
    methods: {
        /**
         * Switch to customer and close the dropdown menu
         *
         * @param {object} customer
         */
        switchToCustomer(customer) {
            this.switchCustomer(customer);
            this.$emit('closeDropdownMenu');
        }
    }
};
</script>
